/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/LightMode';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const LightModeIcon = withMuiAdapter(Base, 'LightMode');
